import React, { useState, useEffect,useContext } from 'react'
import '../../styles/create_template.css';

import { Link,useParams } from 'react-router-dom'
import BackLoader from '../../components/backloader';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext'
import { useNavigate } from 'react-router-dom'
import DynamicIcon from '../../components/dynamicicon'
import JisButton from '../../components/controls/jisButton';


function ViewTemplate() {
const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
    const {id} = useParams();
  //  const linkurl=id==null?'/templates/create':
    const tempUrl= `${Constants.apiUrl}/setup/templates/${id}/details`;
    const [template, setTemplate]=useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [html, setHtml] =useState('');

    useEffect(() => {
        
        LoadTemplate();
    
  }, [id])

  const LoadTemplate=()=>{
    setIsLoading(true);
    fetch(tempUrl, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
            setIsLoading(false);
            if(data.code==0){
                setTemplate(data.template);
              setHtml(atob(data.template.html))  ;
            }
            
        })
        .catch(error => {
            console.error(error);
            setIsLoading(false);
        })
}

  return (
    <div className='view-temp'>
     
        <div className="body">
          
            <div className="back" onClick={() => window.history.back()}>
                <Link> <DynamicIcon iname='arrow_back' /> Back</Link>
            </div>

            <div className="doc">
                <h3>{template.title}</h3>
                <div className="paper-doc"> <div className='htmlwrap' dangerouslySetInnerHTML={{__html: html}}></div></div>
                <Link to={`/templates/${template.isCaseRelated}/${id}/edit`}><JisButton>Switch to edit mode</JisButton></Link>
            </div>
        </div>
    </div>
  )
}

export default ViewTemplate